import { IFrisbuyWidgetPost } from "../gallery/interfaces";

export function recoveryURL(
  srcDomain: string,
  post: IFrisbuyWidgetPost,
  mediaIndex = 0,
  type = "image",
  isRetina: boolean,
  isStandartLow: boolean,
  getHighResolution: boolean
) {
  const recoveryPath = `${srcDomain}/cdn/forward?fri_post_id=${
    post.frisbuyPost.id
  }&type=${type}&carousel_position=${mediaIndex + 1}`;
  let size = "thumbnail";

  if (!post || !post.media[mediaIndex]) return;

  if (type === "video") {
    return recoveryPath;
  } else {
    if (isRetina || getHighResolution) {
      size = isStandartLow ? "high_resolution" : "standart";
    } else if (isStandartLow) {
      size = "standart";
    }

    return `${recoveryPath}&size=${size}`;
  }
}
